<div class="cmdb-home-screen-container equipment-history-report">
	<h1 class="title">{{ labels.lbl_cmdb }}</h1>
	<div class="header-options">
		<msp-breadcrumb-navigation
			[breadcrumb]="[
				{ route: '/cmdb/list', label: labels.lbl_geral_inicio },
				{
					route: '/cmdb/equipment-history',
					label: labels.lbl_historico_equipamentos_usuario || 'Histórico de Equipamentos por Usuário',
				},
			]">
		</msp-breadcrumb-navigation>
		<div class="interactions-container">
			<div class="search-container">
				<input
					[placeholder]="
						labels.lbl_geral_usuario +
						': ' +
						(labels.lbl_geral_nome_completo || 'nome') +
						', ' +
						(labels.lbl_geral_email || 'e-mail') +
						' ou ' +
						(labels.lbl_geral_login || 'login')
					"
					[title]="labels.lbl_geral_colunas_busca || labels.lbl_geral_usuario"
					[value]="search"
					(keyup)="setGeneralSearch($event)"
					(keydown.enter)="searchHistory()" />
				<button type="button" class="search-button" (click)="searchHistory()" [disabled]="isLoadingHistory">
					<fa-icon [icon]="icons.faMagnifyingGlass"></fa-icon>
				</button>
			</div>
		</div>
	</div>

	<msp-table-rmk
		[headers]="headers"
		[data]="displayedHistory"
		[enableSorting]="true"
		[sort]="tableSort"
		(getSort)="applySort($event)"
		[enableSearching]="true"
		(getSearch)="applyTableSearch($event)"
		(cleanSearch)="clearTableSearch()"
		[enableExport]="true"
		(exportTable)="exportHistory()"
		[isLoading]="isLoadingHistory">
	</msp-table-rmk>
	<div class="pagination-container has-total" *ngIf="!isLoadingHistory && history.length > 0">
		<span></span>
		<cpi-pagination-counter
			[arrayLength]="totalHistory"
			[itemsPerPage]="itemsPerPage"
			[setCurrentPage]="currentPage"
			(getCurrentPage)="setPage($event)">
		</cpi-pagination-counter>
		<span>{{ labels.lbl_geral_registros || 'Registros' }}: {{ displayedHistory.length }}</span>
	</div>
</div>
